import React, { useState } from "react";

const ExamMarksDistributionCalculator = () => {
  const [totalTime, setTotalTime] = useState("");
  const [questions, setQuestions] = useState("");
  const [timePerQuestion, setTimePerQuestion] = useState(null);

  const calculateTime = () => {
    setTimePerQuestion((totalTime / questions).toFixed(2));
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Exam Marks Distribution Calculator</h2>
      {/* <input type="number" placeholder="Total Exam Time (mins)" className="border p-2 w-full mt-3" onChange={(e) => setTotalTime(e.target.value)} />
      <input type="number" placeholder="Total Questions" className="border p-2 w-full mt-3" onChange={(e) => setQuestions(e.target.value)} /> */}
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateTime}>Calculate</button>
      {timePerQuestion && <div className="mt-3 text-center text-lg">Time per Question: <span className="font-bold text-green-600">{timePerQuestion} mins</span></div>}
    </div>
  );
};

export default ExamMarksDistributionCalculator;
